import React from 'react'
import LocationIcon from 'assets/icons/location-icon'
import {InfoHeaderWrapper, InfoHeaderDivider} from './style'

const InfoHeader = ({text}) => {
  return (
    <InfoHeaderWrapper data-testid='test-info-header-wrapper'>
      <InfoHeaderDivider data-testid='test-info-header-divider' />
      <LocationIcon data-testid='test-location-icon' />
      <p style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word',padding: '0 40px'}} data-testid='test-paragraph'>{text}</p>
    </InfoHeaderWrapper>
  )
}

export default InfoHeader
